export const navItems = [
  { path: '/', label: 'Catalog', icon: 'storefront' },
  { path: '/store', label: 'Store Info', icon: 'info' },
  { path: '/browsedesigns', label: 'Browse Designs', icon: 'local_florist' },
];
